const main = () => {
    if(!(document.querySelector('#page-list') || document.querySelector('#page-pickup'))) return
}

export default main